// src/pages/HealthPage.jsx
// Health (3.49.0, Super Admins only): its own page in the left strip's Super
// Admin group, out of the Console (the health emails link to the old
// /console/health address, which still opens it).
import Health from './Health';
import Emo from '../components/Emo';
import { PAGE_TITLE, SECTION_SUB } from '../theme/tabs';

export default function HealthPage() {
  return (
    <div>
      <h2 style={PAGE_TITLE} className="cp-title"><Emo e="🩺" /> Health</h2>
      <p style={{ ...SECTION_SUB, marginTop: -6, marginBottom: 14 }}>
        Whether the fax service is working right now, the daily test fax between our test lines, and the alert emails to admin@.
      </p>
      <Health />
    </div>
  );
}
